import { useEffect, useState } from 'react';

import { RolesFilterProps } from './RolesFilter.decl';

import {
  capitalizeFirstLetter,
  MultiSelect,
  MultiSelectOption,
  ROLE_NAME,
} from '@dashboard/library';
import { useTranslation } from 'react-i18next';

export function RolesFilter({ onSelect, initialRoles }: RolesFilterProps) {
  const { t } = useTranslation();
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
  const options = [
    { label: t('users.filters.roles_filter.agent'), value: ROLE_NAME.AGENT },
    { label: t('permissions.roles.Supervisor'), value: ROLE_NAME.SUPERVISOR },
    { label: t('permissions.roles.Admin'), value: ROLE_NAME.ADMIN },
    { label: t('permissions.roles.Owner'), value: ROLE_NAME.OWNER },
  ];

  function handleSelect(keys: string[]) {
    setSelectedKeys(keys);
    onSelect(keys);
  }

  useEffect(() => {
    setSelectedKeys(initialRoles ?? []);
  }, [initialRoles]);

  return (
    <MultiSelect<MultiSelectOption<string>>
      selectedKeys={selectedKeys}
      defaultSelectedKeys={initialRoles || undefined}
      minWidth='160px'
      options={options}
      onSelect={handleSelect}
      texts={{
        placeholder: capitalizeFirstLetter(t('generic.roles')),
        item: t('generic.role'),
        items: t('generic.roles'),
        result: t('generic.result'),
        results: t('generic.results'),
      }}
    />
  );
}
